import { Helmet } from 'react-helmet-async';

const defaultMeta = {
  title: 'Ella Gold Official',
  description: 'Exclusieve digitale kunst en premium content van Ella Gold. Ontdek unieke AI-gegenereerde kunstwerken en word lid van onze exclusieve community.',
  image: '/og-image.jpg',
  url: 'https://ellagold.com',
  type: 'website'
};

export default function SEO({ 
  title, 
  description, 
  image, 
  url, 
  type = 'website',
  noIndex = false,
  article = null 
}) {
  const seo = {
    title: title ? `${title} | Ella Gold Official` : defaultMeta.title,
    description: description || defaultMeta.description,
    image: image || defaultMeta.image,
    url: url || defaultMeta.url,
    type: type
  };

  return (
    <Helmet>
      {/* Basic Meta */}
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={seo.url} />
      
      {/* Robots */}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph */}
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:type" content={seo.type} />
      <meta property="og:site_name" content="Ella Gold Official" />
      <meta property="og:locale" content="nl_NL" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      
      {/* Article specific (for blog posts/news) */}
      {article && (
        <>
          <meta property="article:published_time" content={article.publishedTime} />
          {article.modifiedTime && <meta property="article:modified_time" content={article.modifiedTime} />}
          {article.author && <meta property="article:author" content={article.author} />}
          {article.tags && article.tags.map((tag, i) => (
            <meta key={i} property="article:tag" content={tag} />
          ))}
        </>
      )}
      
      {/* Additional Meta */}
      <meta name="theme-color" content="#D4AF37" />
      <meta name="author" content="Ella Gold" />
      <meta name="keywords" content="Ella Gold, digitale kunst, AI art, premium content, exclusieve galerij, NFT, digital art" />
    </Helmet>
  );
}
